<template>
  <div class="div_Content" id="appMain">
    <div class="code_box" v-if="IsShowPhoneNum">
      <van-field placeholder="请输入手机号" v-model="PhoneNum" style="width: 90%"> </van-field>
      <van-button
        type="info"
        class="code_btn"
        :disabled="60 > SecurityCodeBntInfo.timeSpan"
        @click="handelGetSecurityCode()"
      >
        {{ SecurityCodeBntInfo.Content }}
      </van-button>
    </div>
    <van-field :placeholder="Placeholder" v-model="SafeCode" @on-enter="handleLogin" :disabled="disabled" maxlength="6">
    </van-field>
    <van-button type="info" class="login_btn" :disabled="disabled" @click="handleLogin()" :loading="loading">
      {{ IsShowPhoneNum ? '登 录' : '验 证' }}</van-button>
    <div class="notice">
      <van-checkbox v-model="checked" icon-size="14px"> </van-checkbox>
      <div class="notice_text">
        我阅读并已同意
        <span @click="openProtocol">《用户使用协议》</span>
        <!-- <span @click="openPolicy">《“云影像”个人信息保护政策》</span> -->
      </div>
    </div>

    <div class="login_footer">
      <h2>易联云影【云影像】</h2>
      <p>
        <span>易联云影信息科技(西安)有限公司 </span>
        <br />
        提供技术支持版权所有
      </p>
      <p>陕ICP备18017417号-1</p>
    </div>
  </div>
</template>

<script>
import {
  SendVerificationCode,
  Login,
  GetSimplePatientReportInfo,
  GetCloudImageConfigInfoByReportID,
} from '@/api/CloudFilmService'
import { setLoginName, setNextTimeRouter, getNextTimeRouter } from '../../utils/auth'
import * as cacheManage from '../../utils/cacheUtils'
import { encryptDes, DecryptAES } from '../../utils/stringUtils'
import { Toast } from 'vant'
import eventBus from '@/utils/eventBus.js';

export default {
  data() {
    return {
      PhoneNum: '',
      SafeCode: '',
      RepertID: '',
      loading: false,
      Placeholder: '请输入验证码',
      SecurityCodeBntInfo: {
        timeSpan: 60,
        Content: '获取验证码',
      },
      IsShowPhoneNum: true,
      disabled: false,
      TipTxt: '安全码',
      checked: false,
    }
  },
  beforeRouteEnter: (to, from, next) => {
    next((vm) => {
        if (from.name == 'termsService') {
          console.log(1)
          } else {
            Object.assign(vm.$data, vm.$options.data())
          }
    })
  },
  //每次激活时
activated(){
    //根据key名获取传递回来的参数，data就是map
    eventBus.$on('choiceHospital', function(data){
        //赋值给首页的附近医院数据模型
      if (data) {
        this.checked = data;
      }
    }.bind(this));
},
  // 解决安卓手机调出来软键盘，屏幕背景被挤压的问题
  created() {
    // 判断当前系统是ios还是安卓
    let u = navigator.userAgent
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
    if (isAndroid) {
      // 获取当前可视区域的高度
      this.$nextTick(() => {
        const height = document.documentElement.clientHeight
        document.getElementById('appMain').style.height = `${height - 125}px`
      })
    }
  },
  mounted() {
    var dateTime = this.$route.query.dateTime
    if (dateTime && this.moment() > this.moment(DecryptAES(dateTime))) {
      this.$notify({ type: 'warning', message: '二维码已过期！' })
    } else {
      var urls = getNextTimeRouter()
      if (urls) {
        urls = JSON.parse(urls)
      }
      if (urls && window.location.href === urls.CurrentUrl) {
        cacheManage.SetIsLogin(true)
        this.$router.replace(urls.NextUrl)
      } else {
        var reportID = this.$route.query.id
        if (reportID) {
          if (!this.$route.query.securityCode) {
            this.IsShowPhoneNum = false
            this.RepertID = reportID
            this.TipTxt = '安全码'
            GetCloudImageConfigInfoByReportID({ ReportID: reportID }).then((resp) => {
              if (resp.Success) {
                if (resp.Result.CerificateLastDigitsLoginAllowed) {
                  this.TipTxt = this.TipTxt + '/身份证后六位'
                }
                if (resp.Result.TelephoneLastDigitsLoginAllowed) {
                  this.TipTxt = this.TipTxt + '/手机号后六位'
                }
              }
              this.Placeholder = '请输入' + this.TipTxt
            })
          } else {
            cacheManage.SetIsLogin(true)
            this.$router.replace({ path: '/reportView?' + window.location.href.split('?')[1] })
          }
        } else {
          this.IsShowPhoneNum = true
          this.Placeholder = '请输入验证码'
        }
      }
    }
  },
  methods: {
    //发送验证码
    handelGetSecurityCode() {
      if (this.PhoneNum) {
        var phoneNumReg = /^1\d{10}$/
        if (phoneNumReg.test(this.PhoneNum)) {
          SendVerificationCode({ telephone: this.PhoneNum }).then((resp) => {
            if (resp.Success) {
              var timeFlag = setInterval(() => {
                if (this.SecurityCodeBntInfo.timeSpan > 1) {
                  this.SecurityCodeBntInfo.timeSpan -= 1
                  this.SecurityCodeBntInfo.Content = `${this.SecurityCodeBntInfo.timeSpan}秒`
                } else {
                  clearInterval(timeFlag)
                  this.SecurityCodeBntInfo.timeSpan = 60
                  this.SecurityCodeBntInfo.Content = '获取验证码'
                }
              }, 1000)
              this.$notify({ type: 'success', message: '验证码已发送！' })
            } else {
              this.$notify({ type: 'danger', message: resp.Message })
            }
          })
        } else {
          this.$notify('请填写正确的电话号码！')
        }
      } else {
        this.$notify('请填写电话号码！')
      }
    },
    //登录
    handleLogin() {
      // 电话/验证码登录
      if (!this.checked) {
        Toast({
          message: '请先阅读并同意服务条款',
          // position: 'top',
        })
        return
      }
      if (this.IsShowPhoneNum) {
        // 电话/验证码登录
        if (!this.PhoneNum) {
          this.$notify({
            type: 'warning',
            message: '请输入电话号码，获取验证码登录！',
          })
          return
        }
        var phoneNumReg = /^1\d{10}$/
        if (!phoneNumReg.test(this.PhoneNum)) {
          this.$notify('请填写正确的电话号码！')
          return
        }
        if (!this.SafeCode) {
          this.$notify({ type: 'warning', message: '验证码不能为空！' })
          return
        }
        this.disabled = true
        this.loading = true
        //短信验证码 登录
        Login({ telephone: this.PhoneNum, verificationcode: this.SafeCode })
          .then((resp) => {
            if (resp.Success) {
              setLoginName(this.PhoneNum)
              cacheManage.SetPhoneNum(this.PhoneNum)
              cacheManage.SetIsShowReportListBtn(true)
              cacheManage.SetIsLogin(true)
              cacheManage.SetCloudImagePatientInfo(resp.Result)
              setNextTimeRouter(window.location.href, 20)
              var NextUrl = { path: '/ReportListView' }
              setNextTimeRouter(JSON.stringify({ CurrentUrl: window.location.href, NextUrl: NextUrl }), 20)
              this.$router.replace(NextUrl)
            }
            this.loading = false
            this.disabled = false
          })
          .catch(() => {
            this.loading = false
            this.disabled = false
          })
      } else {
        //安全码登录
        if (!this.SafeCode) {
          this.$notify({
            type: 'warning',
            message: this.TipTxt + '不能为空！',
          })
          return
        }
        this.disabled = true
        this.loading = true
        GetSimplePatientReportInfo({
          patientReportID: this.RepertID,
          securityCode: encryptDes(this.SafeCode),
        })
          .then((resp) => {
            if (resp.Success && resp.Result) {
              if (DecryptAES(this.$route.query.isEncryption) === '1') {
                resp.Result.PatientName = '***'
              }
              cacheManage.SetReportInfo(resp.Result)
              const isShare = DecryptAES(this.$route.query.isShare) === '1' // 判断是不是分享过来的数据，分享过来的数据不显示分享按钮
              cacheManage.SetIsShowShareBtn(!isShare)
              cacheManage.SetIsShowReportListBtn(false)
              cacheManage.SetIsLogin(true)
              var NextUrl = { path: '/reportView?' + window.location.href.split('?')[1] }
              setNextTimeRouter(JSON.stringify({ CurrentUrl: window.location.href, NextUrl: NextUrl }), 20)
              this.$router.replace(NextUrl)
            } else {
              this.$notify({ type: 'danger', message: resp.Message })
            }
            this.loading = false
            this.disabled = false
          })
          .catch(() => {
            this.loading = false
            this.disabled = false
          })
      }
    },
    openProtocol() {
      this.$router.push('/termsService')
    },
    // openPolicy() {
    //   this.$router.push('/termsService')
    // },
  },
}
</script>
<style  scoped>
.div_Content {
  width: 100%;
  height: calc(100vh - 125px);
  border-radius: 10px;
  box-shadow: 0 0 14px rgba(186, 195, 209, 0.5);
  position: relative;

  /* position: fixed;
  left: 0;
  top: 135px; */
  background: #fff;
  padding: 28px 15px;
}

.login_text {
  width: 100%;
  border-bottom: #eaeaea 1px solid;
  margin-bottom: 15px;
  overflow: hidden;
}

.login_text span {
  width: 18px;
  float: left;
  margin-top: 6px;
}

.login_text input {
  width: 90%;
  float: left;
  height: 30px;
  padding-left: 8px;
  font-size: 15px;
  color: #111;
}

input::-webkit-input-placeholder {
  color: #c3c3c3;
}

input::-moz-input-placeholder {
  color: #c3c3c3;
}

input::-ms-input-placeholder {
  color: #c3c3c3;
}

.login_btn {
  width: 100%;
  height: 44px;
  border-radius: 22px;
  color: #fff;
  background-color: #40a5ff;
  border: #40a5ff;
  box-shadow: 0 0 14px rgba(190, 218, 215, 0.6);
  font-size: 18px;
  line-height: 44px;
  text-align: center;
  margin-top: 32px;
}

.login_footer {
  width: 80%;
  margin: 0 auto;
  position: absolute;
  left: 10%;
  bottom: 20px;
  text-align: center;
}
.login_footer h2 {
  font-size: 14px;
  color: #555;
  line-height: 30px;
  font-weight: 900;
}

.login_footer p {
  font-size: 11px;
  color: #999;
  line-height: 18px;
}

.login_footer p span {
  font-size: 13px;
  color: #333;
}
.code_btn {
  width: 160px;
  height: 30px;
  margin-top: 10px;
  border-radius: 15px;
  font-size: 0.875rem;
  background-color: #40a5ff;
  border: #40a5ff;
}
.code_box {
  width: 100%;
  justify-items: center;
  display: inline-flex;
}
.notice {
  margin-top: 30px;
  font-size: 12px;
  display: flex;
}

::v-deep .van-checkbox__label {
  color: gray;
}
.notice_text {
  color: gray;
}
.notice_text span {
  color: #40a5ff;
  font-weight: 600;
  /* text-decoration: underline; */
}
::v-deep .van-checkbox {
  padding-right: 3px;
  margin-right: 10px;
  align-items: flex-start;
}
::v-deep .van-checkbox__icon {
  margin-top: 2px;
}
</style>